<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core';
import { PopoverContent, type PopoverContentEmits, type PopoverContentProps, PopoverPortal, useForwardPropsEmits } from 'radix-vue';
import { type HTMLAttributes } from 'vue';

import { cn } from '@/components/lib/shadcn-vue/utils';

defineOptions({
  inheritAttrs: false,
});

interface Props extends PopoverContentProps {
  class?: HTMLAttributes['class'];
  // モーダルやドロワーの中で使うときは true にする。body へ出すと、親のフォーカストラップと外側クリック判定から外れる
  disablePortal?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  align: 'start',
  side: 'bottom',
  sideOffset: 0,
  class: '',
  disablePortal: false,
});
const emits = defineEmits<PopoverContentEmits>();

const delegatedProps = reactiveOmit(props, 'disablePortal');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <PopoverPortal :disabled="props.disablePortal">
    <PopoverContent
      v-bind="{ ...forwarded, ...$attrs }"
      :class="
        cn(
          'bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 translate-y-[-1px] border p-4 outline-none',
          props.class,
        )
      "
    >
      <slot />
    </PopoverContent>
  </PopoverPortal>
</template>
